import { useScaleEvents } from '@components/ArtBoard/Canvas/hooks/events'
import { type ArtBoardMode, artBoardActions } from '@store/reducers/artboard'
import type { AppState } from '@store/types'
import { setHideArrows } from '@storeOld/reducers/canvas/canvas'
import { useDispatch, useSelector } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { useArtboardMode } from '@/hooks'
import { createSwitch } from '@/utils'

export const useViewMenu = () => {
  const dispatch = useDispatch()
  const { onResetZoom, onFit, onSetZoom } = useScaleEvents()

  const arrowsHide = useSelector<AppState, boolean>(
    ({ canvas }) => canvas.arrow.hideArrows
  )

  const { simpleView } = useArtboardMode()

  const switcher = createSwitch()
    .case(['150%'], () => {
      sendGtmEvent(GtmTriggerName.ZOOM_150)
      onSetZoom(1.5)
    })
    .case(['100%'], () => {
      sendGtmEvent(GtmTriggerName.ZOOM_100)
      onSetZoom(1)
    })
    .case(['75%'], () => {
      sendGtmEvent(GtmTriggerName.ZOOM_75)
      onSetZoom(0.75)
    })
    .case(['50%'], () => {
      sendGtmEvent(GtmTriggerName.ZOOM_50)
      onSetZoom(0.5)
    })
    .case(['center'], () => {
      sendGtmEvent(GtmTriggerName.ZOOM_CENTER)
      onResetZoom()
    })
    .case(['fit'], () => {
      sendGtmEvent(GtmTriggerName.ZOOM_FIT)
      onFit()
    })
    .case(['hide_blocks'], () => {
      sendGtmEvent(GtmTriggerName.BLOCKS_HIDE)
      const mode: ArtBoardMode = simpleView ? 'edit' : 'simple_view'
      onResetZoom()
      dispatch(artBoardActions.changeMode(mode))
    })
    .case(['hide_arrows'], () => {
      sendGtmEvent(GtmTriggerName.ARROWS_HIDE)
      dispatch(setHideArrows(!arrowsHide))
    })

  const onViewClick = (keys: string[]) => switcher.run(keys)

  return { onViewClick }
}
